var map = {
	"./system.js": "Y7B7",
	"./takeout.js": "X0Cb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3R3";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules nonrecursive [\w-]+\.js$
// module id = e3R3
// module chunks = 227